import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { forwardRef } from 'react';

import { styled } from '../stitches';

const Container = styled('button', {
  outline: 'none',
  appearance: 'none',
  padding: '$4',
  '& svg .focus-outline': {
    opacity: 0,
  },
  '&:focus svg .focus-outline': {
    opacity: 1,
  },
});

function SettingsIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="-2 -2 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 10.7289 15.814 13.8076 14.8139 14.8105C13.8139 15.8134 10.2326 16 8.02326 16C5.81394 16 2.23257 15.8134 1.23256 14.8105C0.232559 13.8076 0 10.7289 0 8C0 5.27115 0.232557 2.19243 1.23256 1.1895C2.23257 0.186588 5.81394 0 8.02326 0C10.2326 0 13.814 0.186588 14.814 1.1895C15.814 2.19243 16 5.27115 16 8Z"
        fill="#66687A"
      />
      <path
        d="M13.3589 9.32177L12.372 8.77621C12.4717 8.26164 12.4717 7.73393 12.372 7.21936L13.3589 6.67379C13.4136 6.64337 13.4559 6.59614 13.4791 6.53978C13.5022 6.48342 13.5048 6.42123 13.4863 6.36331C13.2313 5.58284 12.7985 4.86629 12.2191 4.26532C12.1765 4.22086 12.1194 4.19159 12.0571 4.18232C11.9948 4.17306 11.931 4.18434 11.8763 4.21431L10.8894 4.75988C10.4749 4.4184 9.99714 4.15436 9.48095 3.98145V2.89254C9.48093 2.83219 9.45948 2.77363 9.42012 2.72648C9.38076 2.67933 9.32583 2.64639 9.26435 2.63306C8.43129 2.45565 7.56769 2.45565 6.73464 2.63306C6.67294 2.64617 6.61774 2.67902 6.57816 2.72619C6.53857 2.77336 6.51696 2.83203 6.51688 2.89254V3.98367C6.00197 4.15925 5.52471 4.42302 5.1084 4.7621L4.12269 4.21653C4.06811 4.18607 4.00424 4.17451 3.94181 4.1838C3.87938 4.19308 3.82219 4.22265 3.77984 4.26754C3.19954 4.86782 2.76662 5.5846 2.51267 6.36552C2.49375 6.42343 2.49608 6.48578 2.51925 6.54225C2.54242 6.59872 2.58505 6.64591 2.64008 6.67601L3.62694 7.22157C3.52733 7.73614 3.52733 8.26386 3.62694 8.77843L2.64008 9.32399C2.5853 9.35433 2.54287 9.40154 2.51973 9.45793C2.49659 9.51432 2.4941 9.57656 2.51267 9.63448C2.76758 10.415 3.20039 11.1316 3.77984 11.7325C3.82247 11.7769 3.87963 11.8062 3.94193 11.8155C4.00423 11.8247 4.06797 11.8134 4.12269 11.7835L5.10955 11.2379C5.524 11.5795 6.00178 11.8436 6.51804 12.0163V13.1075C6.51812 13.168 6.53973 13.2266 6.57931 13.2738C6.6189 13.321 6.67409 13.3538 6.7358 13.3669C7.56885 13.5444 8.43245 13.5444 9.2655 13.3669C9.32721 13.3538 9.3824 13.321 9.42198 13.2738C9.46157 13.2266 9.48318 13.168 9.48326 13.1075V12.0163C9.99815 11.8407 10.4754 11.5769 10.8917 11.2379L11.8786 11.7835C11.9332 11.8139 11.9971 11.8254 12.0595 11.8161C12.1219 11.8069 12.1791 11.7773 12.2215 11.7325C12.8018 11.1322 13.2348 10.4154 13.4886 9.63448C13.5064 9.57596 13.5033 9.51346 13.4798 9.45683C13.4563 9.4002 13.4138 9.35268 13.3589 9.32177ZM7.99833 10.1246C7.55894 10.1246 7.12942 9.99986 6.76408 9.76616C6.39874 9.53247 6.11399 9.2003 5.94584 8.81168C5.77769 8.42305 5.7337 7.99542 5.81942 7.58286C5.90514 7.1703 6.11673 6.79134 6.42742 6.4939C6.73812 6.19646 7.13397 5.9939 7.56492 5.91183C7.99587 5.82977 8.44256 5.87189 8.8485 6.03286C9.25445 6.19384 9.60141 6.46643 9.84553 6.81619C10.0896 7.16594 10.2199 7.57714 10.2199 7.99778C10.22 8.27709 10.1625 8.55366 10.0509 8.81171C9.93925 9.06976 9.77561 9.30423 9.56931 9.50173C9.36301 9.69923 9.11809 9.85589 8.84854 9.96276C8.57899 10.0696 8.29009 10.1246 7.99833 10.1246Z"
        fill="#FAFAFC"
      />
      <path
        d="M8.00005 9.20078C7.76271 9.20078 7.5307 9.1304 7.33336 8.99855C7.13603 8.86669 6.98222 8.67927 6.89139 8.46C6.80057 8.24073 6.7768 7.99945 6.82311 7.76667C6.86941 7.5339 6.9837 7.32008 7.15152 7.15225C7.31934 6.98443 7.53316 6.87014 7.76594 6.82384C7.99872 6.77754 8.24 6.8013 8.45927 6.89213C8.67854 6.98295 8.86595 7.13676 8.99781 7.3341C9.12967 7.53144 9.20005 7.76344 9.20005 8.00078C9.20005 8.15837 9.16901 8.31441 9.1087 8.46C9.0484 8.60559 8.96001 8.73788 8.84858 8.84931C8.73715 8.96074 8.60486 9.04913 8.45927 9.10944C8.31368 9.16974 8.15764 9.20078 8.00005 9.20078Z"
        fill="#E4E6F0"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 10.7289 15.814 13.8076 14.8139 14.8105C13.8139 15.8134 10.2326 16 8.02326 16C5.81394 16 2.23257 15.8134 1.23256 14.8105C0.232559 13.8076 0 10.7289 0 8C0 5.27115 0.232557 2.19243 1.23256 1.1895C2.23257 0.186588 5.81394 0 8.02326 0C10.2326 0 13.814 0.186588 14.814 1.1895C15.814 2.19243 16 5.27115 16 8Z"
        className="focus-outline"
        stroke="#6977E1"
        strokeWidth={1}
      />
    </svg>
  );
}

export const SettingsButton = forwardRef<
  HTMLButtonElement,
  DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
>((props, ref) => (
  <Container {...props} ref={ref}>
    <SettingsIcon />
  </Container>
));
